import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the tab and its detail routes a "Product types" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/org/catalog-setup/product-types')({
  staticData: { crumb: 'dictionary:setup.tabs.productTypes' },
  component: Outlet,
});
